import React from 'react';

import {Text} from '#component/base';
import {UncertainProgress} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import {FullscreenLoadingProps} from './FullscreenLoading.types';

import * as css from './FullscreenLoading.css';

const DEFAULT_TEXT = 'Give us a moment... we’re loading your information.';

export const FullscreenLoading: React.FC<FullscreenLoadingProps> = ({text, subText}) => {
  return (
    <div className={css.root}>
      <div className={css.content}>
        <UncertainProgress width={144} size={24} duration={1} />

        <div className={sprinkles({flex: 'flex', dir: 'col', gap: 8})}>
          <Text color="burgundy" textAlign="center">
            {text || DEFAULT_TEXT}
          </Text>

          {subText && (
            <Text color="burgundy" fontWeight="semiBold" variant="caption" textAlign="center">
              {subText}
            </Text>
          )}
        </div>
      </div>
    </div>
  );
};
